import { SEOBaseProps } from './Seo.types';

export default function SEO({
  children,
  title,
  pathname,
  description,
  canonical,
  image,
  site,
}: SEOBaseProps) {
  const metaDescription = description || site.siteMetadata.description;
  const metaKeywords = site.siteMetadata.keywords.join(', ');
  const url = `${site.siteMetadata.siteUrl}${pathname}`;
  const canonicalUrl = canonical
    ? `${site.siteMetadata.siteUrl}${canonical}`
    : url;

  const mainFavicon =
    process.env.NODE_ENV === 'development' ||
    process.env.CONTEXT !== 'production'
      ? 'favicon-dev'
      : 'favicon';
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{title || site.siteMetadata.title}</title>
      <meta name="title" content={title || site.siteMetadata.title} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charSet="utf-8" />

      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />
      {/* Favicons */}
      <link rel="icon" type="image/svg+xml" href={`/${mainFavicon}.svg`} />
      <link rel="icon" href={`/${mainFavicon}.ico`} sizes="32x32" />
      <link rel="icon" href="/favicon-128.png" sizes="128x128" />
      <link rel="icon" href="/favicon-192.png" sizes="192x192" />
      {/* Android */}
      <link rel="icon" href="/favicon-196.png" sizes="196x196" />
      {/* iOS */}
      <link rel="apple-touch-icon" href="/favicon-120.png" sizes="120x120" />
      <link rel="apple-touch-icon" href="/favicon-152.png" sizes="152x152" />
      <link rel="apple-touch-icon" href="/favicon-180.png" sizes="180x180" />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} key="ogurl" />
      <meta
        property="og:image"
        content={image || `${site.siteMetadata.siteUrl}/social-card.jpg`}
        key="ogimage"
      />
      <meta property="og:title" content={title} key="ogtitle" />
      <meta
        property="og:site_name"
        content={site.siteMetadata.title}
        key="ogsitename"
      />
      <meta property="og:description" content={metaDescription} key="ogdesc" />
      {/* twitter */}
      <meta property="twitter:title" content={title} />
      <meta property="twitter:url" content={url} key="twitterurl" />
      <meta
        property="twitter:description"
        content={metaDescription}
        key="twitterdesc"
      />
      <meta
        property="twitter:card"
        content="summary_large_image"
        key="twittercard"
      />
      <meta
        property="twitter:image"
        content={image || `${site.siteMetadata.siteUrl}/social-card.jpg`}
        key="twitterimage"
      />
      {/* FB Verification */}
      <meta
        name="facebook-domain-verification"
        content="jpb17ng1dmyeqp71dh42znhhfhty7m"
      />
      {children}
    </>
  );
}
